import _ from "lodash";
import React from "react";

import { STUDENT, STAFF, PARENT } from "Constants/stringConstants";
import MoreItemWithToolTipV2 from "UIComponents/MoreItemWithToolTipV2";
import DotSeparator from "routes/routes/Platform/routes/MessagingV2/components/DotSeparatedText";

import classes from "./CohortSubText.scss";

const CohortSubText = ({ cohort, type, t }) => {
  const count = _.size(_.get(cohort, "userList", []));

  const mapSubtitleTextToUserType = {
    [STUDENT]: t("common:student_count", { count }),
    [STAFF]: t("common:staff_members_count_lowercase", { count }),
    [PARENT]: t("common:family_member_count", { count }),
  };

  const countLabel = mapSubtitleTextToUserType[type];
  if (!countLabel) return null;

  const grades = _.compact(_.map(_.get(cohort, "grades", []), "name"));
  const curriculumLabel = _.get(cohort, "curriculumProgram.label");

  return (
    <div className={classes.container}>
      <span className="text-body-s">{countLabel}</span>
      {!_.isEmpty(grades) && (
        <>
          <DotSeparator />
          <MoreItemWithToolTipV2
            items={grades}
            length={1}
            trigger={["hover"]}
            customClass="text-body-s"
            moreItemCustomClass="text-body-s"
            toolTipItemTextClass="text-tooltip"
            customContainerClass={classes.moreItemContainer}
          />
        </>
      )}
      {curriculumLabel && (
        <>
          <DotSeparator />
          <span className="text-body-s">{curriculumLabel}</span>
        </>
      )}
    </div>
  );
};

export default CohortSubText;
